const _ = require('lodash');

/**
 * Трекеры для аналитики инитятся не сразу. Некоторые умеют накапливать события и
 * отправлять их после загрузки своего базового кода, но некоторые не делают этого.
 *
 * Дабы не терять события, произошедшие до загрузки трекеров, оборачиваем их в Promise.
 *
 * Каждый трекер должен наследоваться от этого класса и создавать свой _initPromise,
 * который будет резолвиться трекером по факту его инициализации.
 *
 * В каждом трекере нужно определить 2 метода, _event и _pageview, которые будут
 * вызываться отсюда через _initPromise.then
 *
 * Так же сюда вынесен общий для трекеров функционал работы с конфигами зависящими от
 * текущего домена.
 */
class BaseTracker {
    constructor () {
        /**
         * Заглушки. Должены быть переопределен в конструкторе класса наследника.
         * Тобишь до вызова методов event и pageview
         */
        this._window = null;

        /**
         * @type {Promise}
         * @protected
         */
        this._initPromise = null;
    }

    /**
     * Отложенное регистрирование события аналитики.
     * @param {Object} data
     * @param {*} args
     */
    event (data, args) {
        this._initPromise
            .then(() => this._event(data, args));
    }

    /**
     * Отложенное регистрирование показа страницы.
     *
     * @param {*} args
     */
    pageview (...args) {
        this._initPromise
            .then(() => this._pageview(...args));
    }

    /**
     * @return {String} - текущая доменная зона (ru, cy, cl, kz)
     * @private
     */
    _domain () {
        return _.last(this._window.location.hostname.split('.'));
    }

    /**
     * Получение конфига для текущей доменной зоны
     *
     * @param {Object} config - объект вида {ru: ..., cl: ..., cy: ..., kz: ...}
     * @return {*}
     * @protected
     */
    _domainConfig (config) {
        return config[this._domain()] || config.ru;
    }
}

module.exports = BaseTracker;



// WEBPACK FOOTER //
// ./services/analytics/trackers/base.js